export default "__VITE_ASSET__b914e49f__"